export interface DashboardWidgetKeywordInput {
  metric: string;
  breakdownDimension?: string | null;
  title?: string | null;
}

const DASHBOARD_WIDGET_METRIC_KEYWORDS: Record<string, string[]> = {
  headcount: ['headcount', 'workforce', 'employees'],
  growth_rate: ['growth', 'growth rate'],
  hiring_rate: ['hiring', 'hire', 'recruiting', 'new hire'],
  attrition_rate: ['attrition', 'turnover', 'departures', 'leaving'],
  tenure: ['tenure'],
  salary: ['salary distribution', 'pay', 'wages', 'earnings'],
  posting_salary: ['posting salary', 'market pay'],
  time_to_fill: ['time to fill'],
  postings_active: ['active postings', 'open jobs'],
  postings_new: ['new postings'],
  postings_removed: ['removed postings'],
  postings_volume: ['posting volume', 'job postings'],
  transitions_inflow: ['inflow', 'incoming talent'],
  transitions_outflow: ['outflow', 'talent leaving'],
  total_compensation: ['total compensation', 'compensation'],
  base_salary: ['base salary', 'base pay'],
  contractor_pay_rate: ['contractor pay', 'contractor rate'],
  overall: ['overall sentiment', 'sentiment'],
  sentiment_top_bottom: ['top and bottom sentiment', 'sentiment extremes'],
};

const DASHBOARD_WIDGET_DIMENSION_KEYWORDS: Record<string, string[]> = {
  geography: ['geography', 'geographic', 'region', 'map', 'location'],
  role: ['role', 'job', 'position'],
  competitors: ['competitor', 'peer', 'benchmark'],
  company: ['company'],
  skills: ['skill', 'skills'],
  seniority: ['seniority'],
  rics: ['industry'],
  gender: ['gender'],
  ethnicity: ['ethnicity'],
  education: ['education'],
  timeseries: ['trend', 'over time'],
};

const DASHBOARD_WIDGET_AMBIGUOUS_TITLE_TOKENS = new Set(['salary']);

export function getDashboardWidgetPromptKeywords(
  widget: DashboardWidgetKeywordInput
): string[] {
  const keywords = new Set<string>(
    DASHBOARD_WIDGET_METRIC_KEYWORDS[widget.metric] ?? []
  );

  if (widget.breakdownDimension) {
    const dimensionWords = DASHBOARD_WIDGET_DIMENSION_KEYWORDS[
      widget.breakdownDimension
    ] ?? [widget.breakdownDimension];
    // biome-ignore lint/suspicious/useIterableCallbackReturn: migrated from develop
    dimensionWords.forEach((keyword) => keywords.add(keyword));
  }

  if (widget.title) {
    widget.title
      .toLowerCase()
      .split(/[^a-z0-9]+/)
      .filter(
        (token) =>
          token.length >= 4 &&
          !DASHBOARD_WIDGET_AMBIGUOUS_TITLE_TOKENS.has(token)
      )
      // biome-ignore lint/suspicious/useIterableCallbackReturn: migrated from develop
      .forEach((token) => keywords.add(token));
  }

  return Array.from(keywords);
}
